import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import {

  MazPhoneNumberInput
} from 'maz-ui'
import Croppa from 'vue-croppa'
import VueApexCharts from 'vue-apexcharts'
import Vue2Filters from 'vue2-filters'
import VueNumber from 'vue-number-animation'
import VueDayjs from 'vue-dayjs-plugin'
import VueTheMask from 'vue-the-mask'
import VueHotkey from 'v-hotkey'


// Importar vue-trix
import VueTrix from 'vue-trix'
import 'trix/dist/trix.css'
import VueMeta from 'vue-meta'

var Vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: true
  },
  number: {
    format: '0',
    thousandsSeparator: '.',
    decimalSeparator: ','
  },
  bytes: {
    decimalDigits: 2
  },
  percent: {
    decimalDigits: 2,
    multiplier: 100,
    decimalSeparator: ','
  },
  currency: {
    symbol: '$',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    showPlusSign: false
  },
  pluralize: {
    includeNumber: false
  },
  ordinal: {
    includeNumber: false
  }
}
Vue.use(VueNumber)
Vue.use(VueApexCharts)
Vue.use(MazPhoneNumberInput)
Vue.use(Croppa)
Vue.use(Vue2Filters, Vue2FiltersConfig)
Vue.use(VueDayjs)
Vue.use(VueTheMask)
Vue.use(VueHotkey)
Vue.use(VueTrix);
Vue.use(VueMeta)
import VueMoment from 'vue-moment'
const moment = require('moment')
require('moment/locale/es')
Vue.config.productionTip = false
Vue.use(VueMoment, {
  moment
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
